var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8625 34.9967C27.5254 34.796 35.196 26.7999 34.9953 17.137C34.7946 7.47413 26.7985 -0.196485 17.1356 0.00423709C7.47273 0.204959 -0.197879 8.201 0.00284299 17.8639C0.203565 27.5268 8.19961 35.1974 17.8625 34.9967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9312 10.8792C22.267 10.8792 21.7285 11.4176 21.7285 12.0819C21.7285 12.7461 22.267 13.2846 22.9312 13.2846C23.5955 13.2846 24.134 12.7461 24.134 12.0819C24.134 11.4176 23.5955 10.8792 22.9312 10.8792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5842 12.4221C14.798 12.4221 12.5314 14.6888 12.5314 17.475C12.5314 20.2612 14.798 22.5279 17.5842 22.5279C20.3704 22.5279 22.6371 20.2612 22.6371 17.475C22.6371 14.6888 20.3704 12.4221 17.5842 12.4221ZM17.5842 20.7119C15.7991 20.7119 14.3473 19.2601 14.3473 17.475C14.3473 15.6899 15.7991 14.2381 17.5842 14.2381C19.3693 14.2381 20.8212 15.6899 20.8212 17.475C20.8212 19.2601 19.3693 20.7119 17.5842 20.7119Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5957 27.735H13.4032C10.005 27.735 7.24011 24.9701 7.24011 21.5719V13.3794C7.24011 9.98115 10.005 7.21631 13.4032 7.21631H21.5957C24.9939 7.21631 27.7588 9.98115 27.7588 13.3794V21.5719C27.7588 24.9701 24.9939 27.735 21.5957 27.735ZM13.4032 9.14612C11.0689 9.14612 9.16993 11.0451 9.16993 13.3794V21.5719C9.16993 23.9062 11.0689 25.8052 13.4032 25.8052H21.5957C23.93 25.8052 25.829 23.9062 25.829 21.5719V13.3794C25.829 11.0451 23.93 9.14612 21.5957 9.14612H13.4032Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsIcon);
export default __webpack_public_path__ + "static/media/ins-icon.efd3befecf7346543600467d5956c0d5.svg";
export { ForwardRef as ReactComponent };